import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IApiResponse } from '../../../../shared/models/api-response';
import { environment } from '../../../../../environments/environment';
import { convertStringDateToJSDate } from '../../../../shared/utilities/date-utility';
import { ICreateCiBallotRequest } from '../models/ci/create-ci-ballot-request';
import { ICommitteeInternalBallotDto } from '../models/ci/committee-internal-ballot-dto';
import { IUpdateBallotNoteRequest } from '../models/ballot-base/update-ballot-note-request';
import { IUpdateBallotDatesRequest } from '../models/ballot-base/update-ballot-dates-request';
import { IFinaliseCiBallotRequest, IProxyVoteRequest, IVoteRequest } from '../models/ci/ci-vote';
import { IBlobFile } from '../../../../shared/models/blob-file';
import { convertObjectToFormData } from '../../../../shared/utilities/form-data-utility';

@Injectable({
  providedIn: 'root'
})
export class CiBallotService {

  baseUrl: string = `${environment.servicesUrl.ballot}api/ballots/ci`;

  constructor(
    private http: HttpClient,
  ) { }

  public createBallot(request: ICreateCiBallotRequest): Observable<HttpEvent<any>> {
    const formData = convertObjectToFormData(request);

    return this.http.post<HttpEvent<any>>(this.baseUrl, formData, {
      reportProgress: true,
      observe: 'events',
    });
  }

  public getCiBallotDetails(ballotId: string): Observable<IApiResponse<ICommitteeInternalBallotDto>> {
    return this.http.get<IApiResponse<ICommitteeInternalBallotDto>>(`${this.baseUrl}/${ballotId}`)
      .pipe(
        map(rawResponse => {
          let response = { ...rawResponse };
          response.content.ballotSummary.startDate = convertStringDateToJSDate(response.content.ballotSummary.startDate as any);
          response.content.ballotSummary.endDate = convertStringDateToJSDate(response.content.ballotSummary.endDate as any);

          return response;
        })
      );
  }

  public updateBallotNote(request: IUpdateBallotNoteRequest): Observable<IApiResponse<string>> {
    return this.http.put<IApiResponse<string>>(`${this.baseUrl}/${request.ballotId}/notes`, request);
  }

  public updateBallotDates(request: IUpdateBallotDatesRequest): Observable<IApiResponse<string>> {
    return this.http.put<IApiResponse<string>>(`${this.baseUrl}/${request.ballotId}/dates`, request);
  }

  public downloadSupportingDocument(ballotId: string) : Observable<IApiResponse<IBlobFile>> {
    return this.http.get<IApiResponse<IBlobFile>>(`${environment.servicesUrl.ballot}api/blobs/ballots/ci/${ballotId}/supporting-documents`);
  }

  public placeVote(vote: IVoteRequest): Observable<IApiResponse<any>> {
    return this.http.post<IApiResponse<any>>(`${this.baseUrl}/${vote.ballotId}/committee-members/${vote.committeeMemberIds[0]}/votes`, vote);
  }

  public submitProxyVote(request: IProxyVoteRequest) : Observable<HttpEvent<any>> {
        const formData = convertObjectToFormData(request);

        return this.http.post<HttpEvent<any>>(`${this.baseUrl}/${request.ballotId}/proxy-vote`, formData, {
          reportProgress: true,
          observe: 'events',
        });
  }

  public finaliseBallot(ballotId: string, request: IFinaliseCiBallotRequest): Observable<IApiResponse<any>> {
    return this.http.post<IApiResponse<any>>(`${this.baseUrl}/${ballotId}/finalise`, request);
  }


}
